export enum OrderStatusEnum {
	Successful = 'successful',
	Refunded = 'refunded',
	PendingRefund = 'pending-refund',
	Pending = 'pending',
	Failed = 'failed',
}
